// Field validation constants
export const FIELD_VALIDATIONS = {
  LOCATION_NAME: {
    MAX_LENGTH: 50,
    MAX_LENGTH1: 10,
    MAX_LENGTH2: 15,
    ERROR_MESSAGE: 'Limit exceeds 50 characters',
    ERROR_MESSAGE1: 'Limit exceeds 10 characters',
    ERROR_MESSAGE2: 'Limit exceeds 15 characters'
  }
} as const;
